import knowledgeFileData from '@/generated/knowledge.json'
import type { KnowledgeFile, KnowledgeItem } from '@/types/knowledge.js'

const knowledgeFile = knowledgeFileData as KnowledgeFile
const itemById = new Map(knowledgeFile.items.map((item) => [item.id, item]))

export const KNOWLEDGE_ITEMS: readonly KnowledgeItem[] = knowledgeFile.items

export function getKnowledgeItem(id: string): KnowledgeItem | undefined {
  return itemById.get(id)
}

export function getAdjacentKnowledgeItem(
  id: string,
  direction: 'previous' | 'next',
): KnowledgeItem | undefined {
  const index = knowledgeFile.items.findIndex((item) => item.id === id)
  if (index < 0) return undefined
  return knowledgeFile.items[index + (direction === 'previous' ? -1 : 1)]
}
